<template>
  <div class="container p-0 pb-10">
    <v-row>
      <v-col
        cols="12"
        class="mb-3"
      >
        <v-menu
          ref="showDateDialog"
          v-model="showDateDialog"
          :close-on-content-click="false"
          :return-value.sync="dateSelect"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="dateSelectDisplay"
              label="วันที่"
              outlined
              v-bind="attrs"
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dateSelect"
            no-title
            @change="
              $refs.showDateDialog.save(dateSelectDisplay);
              showDateDialog = false;
              changeSlug(slug);
            "
          />
        </v-menu>
      </v-col>
    </v-row>
    <div class="row mb-3 justify-content-start">
      <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('soidown_5')"
          class="btn text-lg btn-outline-yellow w-100 px-0"
          type="button"
          @click="changeSlug('soidown_5')"
        >
          สอยดาว 5 นาที
        </button>
      </div>
      <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('soidown')"
          class="btn text-lg btn-outline-yellow w-100 px-0"
          type="button"
          @click="changeSlug('soidown')"
        >
          สอยดาว 10 นาที
        </button>
      </div>
      <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('soidown_15')"
          class="btn text-lg btn-outline-yellow w-100 px-0"
          type="button"
          @click="changeSlug('soidown_15')"
        >
          สอยดาว 15 นาที
        </button>
      </div>
      <!-- <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('yeekee_thl_5')"
          class="btn text-lg btn-outline-orange w-100 px-0"
          type="button"
          @click="changeSlug('yeekee_thl_5')"
        >
          thailotto 5 นาที
        </button>
      </div> -->
      <!-- <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('yeekee_lto_5')"
          class="btn text-lg btn-outline-blue w-100 px-0"
          type="button"
          @click="changeSlug('yeekee_lto_5')"
        >
          lto 5 นาที
        </button>
      </div> -->
      <!-- <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('yeekee_huay_5')"
          class="btn text-lg btn-outline-info w-100 px-0"
          type="button"
          @click="changeSlug('yeekee_huay_5')"
        >
          huay 5 นาที
        </button>
      </div> -->
      <!-- <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('yeekee_chj_5')"
          class="btn text-lg btn-outline-primary w-100 px-0"
          type="button"
          @click="changeSlug('yeekee_chj_5')"
        >
          chudjen 5 นาที
        </button>
      </div> -->
      <!-- <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('yeekee_dna_5')"
          class="btn text-lg btn-outline-blue-dark w-100 px-0"
          type="button"
          @click="changeSlug('yeekee_dna_5')"
        >
          dna 5 นาที
        </button>
      </div> -->
      <div class="col-6 col-sm-3 col-lg-3 col-xl-2 mb-3">
        <button
          :class="classActive('lotto_thai')"
          class="btn text-lg btn-outline-success w-100 px-0"
          type="button"
          @click="changeSlug('lotto_thai')"
        >
          หวยรัฐ / หวยหุ้น
        </button>
      </div>
    </div>
    <div
      v-if="slug != 'lotto_thai'"
      class="row mb-3"
    >
      <div class="col-6">
        <button
          :class="typeActive('short')"
          class="btn text-lg btn-outline-dark w-100 px-0"
          type="button"
          @click="changeType('short')"
        >
          มุมมองสั้น
        </button>
      </div>
      <div class="col-6">
        <button
          :class="typeActive('long')"
          class="btn text-lg btn-outline-dark w-100 px-0"
          type="button"
          @click="changeType('long')"
        >
          มุมมองยาว
        </button>
      </div>
    </div>
    <div
      v-if="viewType == 'short'"
      class="row mb-3"
    >
      <div class="col-12 mb-3">
        <div class="card">
          <div
            id="short_title"
            class="card-header text-left text-white"
            :class="
              slug == 'soidown' || slug == 'soidown_5' || slug == 'soidown_15'
                ? 'bg-yellow'
                : slug == 'yeekee_thl_5' || slug == 'yeekee_thl_15'
                  ? 'bg-orange'
                  : slug == 'yeekee_lto_5' || slug == 'yeekee_lto_15'
                    ? 'bg-blue'
                    : slug == 'yeekee_huay_5' || slug == 'yeekee_huay_15'
                      ? 'bg-info'
                      : slug == 'yeekee_chj_5' || slug == 'yeekee_chj_15'
                        ? 'bg-primary'
                        : slug == 'yeekee_dna_5' || slug == 'yeekee_dna_15'
                          ? 'bg-blue-dark'
                          : slug == 'soidown_vip'
                            ? 'bg-purple'
                            : 'bg-success'
            "
          >
            {{ roundCurrent }} {{ gameThaiDate }}
          </div>
          <div class="card-body d-flex">
            <div class="flex-width border-right border-gray">
              <h5 class="text-center">
                สามตัวบน
              </h5>
              <h4
                id="short_result_tripple"
                class="text-center text-black"
              >
                {{ treeDigitCurrent }}
              </h4>
            </div>
            <div class="flex-width">
              <h5 class="text-center">
                สองตัวล่าง
              </h5>
              <h4
                id="short_result_double"
                class="text-center text-black"
              >
                {{ twoDigitCurrent }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div
          v-for="reward in dataRewards"
          :key="reward.id"
          class="button-result-short"
        >
          <button
            :id="reward.id"
            :class="buttonActive(reward.id)"
            class="btn-round-short btn btn-outline-dark px-0 py-0 h-100 w-100 mx-0 my-0"
            @click="
              changeCurrent(
                reward.master.name + reward.readable_edition,
                reward.results.length > 1
                  ? reward.results[0].result_value
                  : 'รอผล',
                reward.results.length > 1
                  ? reward.results[1].result_value
                  : 'รอผล'
              )
            "
          >
            {{ spritRoundName(reward.edition_slug) }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div
        v-if="slug != 'lotto_thai'"
        class="col-12 mb-3"
      >
        <div class="card">
          <div
            id="short_title"
            class="card-header text-left text-white"
            :class="
              slug == 'soidown' || slug == 'soidown_5' || slug == 'soidown_15'
                ? 'bg-yellow'
                : slug == 'yeekee_thl_5' || slug == 'yeekee_thl_15'
                  ? 'bg-orange'
                  : slug == 'yeekee_lto_5' || slug == 'yeekee_lto_15'
                    ? 'bg-blue'
                    : slug == 'yeekee_huay_5' || slug == 'yeekee_huay_15'
                      ? 'bg-info'
                      : slug == 'yeekee_chj_5' || slug == 'yeekee_chj_15'
                        ? 'bg-primary'
                        : slug == 'yeekee_dna_5' || slug == 'yeekee_dna_15'
                          ? 'bg-blue-dark'
                          : slug == 'soidown_vip'
                            ? 'bg-purple'
                            : 'bg-success'
            "
          >
            {{ roundCurrent }} {{ gameThaiDate }}
          </div>
          <div class="card-body d-flex">
            <div class="flex-width border-right border-gray">
              <h5 class="text-center">
                สามตัวบน
              </h5>
              <h4
                id="short_result_tripple"
                class="text-center text-black"
              >
                {{ treeDigitCurrent }}
              </h4>
            </div>
            <div class="flex-width">
              <h5 class="text-center">
                สองตัวล่าง
              </h5>
              <h4
                id="short_result_double"
                class="text-center text-black"
              >
                {{ twoDigitCurrent }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="reward in dataRewards"
        v-if="idCurrent != reward.id"
        :key="reward.id"
        :class="
          reward.master.slug == 'lotto_thai' ||
            reward.master.slug == 'lotto_thai2'
            ? 'col-12'
            : 'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2'
        "
        class="rounded-lg mb-2"
      >
        <div
          class="px-0 py-1 rounded-lg-top"
          :class="
            reward.master.slug == 'lotto_thai' ||
              reward.master.slug == 'lotto_thai2'
              ? 'bg-ktb'
              : reward.master.slug == 'soidown' ||
                reward.master.slug == 'soidown_5' ||
                reward.master.slug == 'soidown_15'
                ? 'bg-yellow'
                : reward.master.slug == 'yeekee_thl_5' ||
                  reward.master.slug == 'yeekee_thl_15'
                  ? 'bg-orange'
                  : reward.master.slug == 'yeekee_lto_5' ||
                    reward.master.slug == 'yeekee_lto_15'
                    ? 'bg-blue'
                    : reward.master.slug == 'yeekee_huay_5' ||
                      reward.master.slug == 'yeekee_huay_15'
                      ? 'bg-info'
                      : reward.master.slug == 'yeekee_chj_5' ||
                        reward.master.slug == 'yeekee_chj_15'
                        ? 'bg-primary'
                        : reward.master.slug == 'yeekee_dna_5' ||
                          reward.master.slug == 'yeekee_dna_15'
                          ? 'bg-blue-dark'
                          : reward.master.slug == 'lotto_baac'
                            ? 'bg-baac'
                            : reward.master.slug == 'lotto_gsb'
                              ? 'bg-gsb'
                              : 'bg-success'
          "
        >
          <div class="w-100 text-center text-white text-lg">
            {{ reward.master.name }}<br>
            {{ reward.readable_edition }}
            {{ reward.game_thai_date }}
          </div>
        </div>
        <div
          v-if="
            reward.master.slug == 'lotto_thai' ||
              reward.master.slug == 'lotto_thai2'
          "
          class="w-100 px-1"
        >
          <div
            v-if="reward.results.length > 0"
            class="border-right border-left border-bottom rounded-bottom py-1"
          >
            <div class="d-flex w-100">
              <div class="flex-width text-center text-xl">
                <small class="text-md">รางวัลที่ 1</small>
              </div>
            </div>
            <div class="d-flex w-100 border-bottom mb-3 pb-3">
              <div class="flex-width text-center text-xl">
                {{ reward.results[0].result_value }}
              </div>
            </div>
            <div class="d-flex w-100">
              <div class="flex-width text-center text-xl">
                <small class="text-md">สามตัวหน้า</small>
              </div>
              <div
                class="flex-width text-center text-xl border-left border-right"
              >
                <small class="text-md">สามตัวหลัง</small>
              </div>
              <div class="flex-width text-center text-xl">
                <small class="text-md">2ตัวล่าง</small>
              </div>
            </div>
            <div class="d-flex w-100">
              <div class="flex-width text-center text-xl">
                {{ reward.results[5].result_value }} ,
                {{ reward.results[4].result_value }}
              </div>
              <div
                class="flex-width text-center text-xl border-left border-right"
              >
                {{ reward.results[3].result_value }} ,
                {{ reward.results[2].result_value }}
              </div>
              <div class="flex-width text-center text-xl">
                {{ reward.results[1].result_value }}
              </div>
            </div>
          </div>
          <div
            v-else
            class="border-right border-left border-bottom rounded-bottom py-1"
          >
            <div class="d-flex w-100">
              <div class="flex-width text-center text-xl">
                <small class="text-md">รางวัลที่ 1</small>
              </div>
            </div>
            <div class="d-flex w-100 border-bottom mb-3 pb-3">
              <div
                v-if="reward.status != 'cancel'"
                class="flex-width text-center text-xl"
              >
                รอผล
              </div>
              <div
                v-else
                class="flex-width text-center text-xl"
              >
                ยกเลิก
              </div>
            </div>
            <div class="d-flex w-100">
              <div class="flex-width text-center text-xl">
                <small class="text-md">สามตัวหน้า</small>
              </div>
              <div
                class="flex-width text-center text-xl border-left border-right"
              >
                <small class="text-md">สามตัวหลัง</small>
              </div>
              <div class="flex-width text-center text-xl">
                <small class="text-md">2ตัวล่าง</small>
              </div>
            </div>
            <div
              v-if="reward.status != 'cancel'"
              class="d-flex w-100"
            >
              <div class="flex-width text-center text-xl">
                รอผล
              </div>
              <div
                class="flex-width text-center text-xl border-left border-right"
              >
                รอผล
              </div>
              <div class="flex-width text-center text-xl">
                รอผล
              </div>
            </div>
            <div
              v-else
              class="d-flex w-100"
            >
              <div class="flex-width text-center text-xl">
                ยกเลิก
              </div>
              <div
                class="flex-width text-center text-xl border-left border-right"
              >
                ยกเลิก
              </div>
              <div class="flex-width text-center text-xl">
                ยกเลิก
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-if="!reward.master.slug.startsWith('step_')"
            class="d-flex border-left border-right py-1"
          >
            <div class="flex-width text-center text-xl text-md">
              สองตัวล่าง
            </div>
            <div class="flex-width text-center text-xl text-md">
              สามตัวบน
            </div>
          </div>
          <div
            v-else
            class="d-flex border-left border-right py-1"
          >
            <div class="flex-width text-center text-xl text-md">
              สี่ตัวบน
            </div>
          </div>
          <div
            v-if="reward.results.length > 0"
            class="d-flex border-right border-left border-bottom rounded-bottom py-1"
          >
            <div
              v-for="result in reward.results"
              :key="result.result_value"
              class="flex-width text-center text-xl text-md text-black"
            >
              {{ result.result_value }}
            </div>
          </div>
          <div
            v-else
            class="d-flex border-right border-left border-bottom rounded-bottom py-1"
          >
            <span
              v-if="!reward.master.slug.startsWith('step_')"
              class="w-100 d-flex"
            >
              <div
                v-if="reward.status != 'cancel'"
                class="flex-width text-center text-xl text-md text-primary"
              >
                รอผล
              </div>
              <div
                v-else
                class="flex-width text-center text-xl text-md text-primary"
              >
                ยกเลิก
              </div>
              <div
                v-if="reward.status != 'cancel'"
                class="flex-width text-center text-xl text-md text-primary"
              >
                รอผล
              </div>
              <div
                v-else
                class="flex-width text-center text-xl text-md text-primary"
              >
                ยกเลิก
              </div>
            </span>
            <span
              v-else
              class="w-100 d-flex"
            >
              <div
                v-if="reward.status != 'cancel'"
                class="flex-width text-center text-xl text-md text-primary"
              >
                รอผล
              </div>
              <div
                v-else
                class="flex-width text-center text-xl text-md text-primary"
              >
                ยกเลิก
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import axios from 'axios';

export default {
  name: 'LottoReward',
  props: {},
  data() {
    return {
      dataRewards: [],
      slug: 'soidown_5',
      viewType: 'short',
      roundCurrent: '',
      gameThaiDate: '',
      idCurrent: '',
      twoDigitCurrent: '',
      treeDigitCurrent: '',
      showDateDialog: false,
      dateSelect: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    dateSelectDisplay() {
      return this.dateSelect;
    },
  },
  mounted() {
    self = this;
    axios
      .get(`/api/lotto/reward/${this.slug}/${this.dateSelect}`)
      .then((response) => {
        self.$set(self, 'dataRewards', response.data);
        const array = response.data;
        let tempRound = '';
        let tempThaiDate = '';
        let tempCurrentRoundID = '';
        let tempTwodigit = '';
        let temptreedigit = '';

        array.forEach((element) => {
          tempRound = `${element.master.name} ${element.readable_edition}`;
          tempThaiDate = element.game_thai_date;
          if (element.status == 'complete') {
            tempCurrentRoundID = element.id;
            tempTwodigit = element.results[0].result_value;
            temptreedigit = element.results[1].result_value;
          }
        });
        self.$set(self, 'roundCurrent', tempRound);
        self.$set(self, 'gameThaiDate', tempThaiDate);
        self.$set(self, 'idCurrent', tempCurrentRoundID);
        self.$set(self, 'twoDigitCurrent', tempTwodigit);
        self.$set(self, 'treeDigitCurrent', temptreedigit);
      });
  },
  methods: {
    changeSlug(value) {
      if (value == 'lotto_thai') {
        this.$set(this, 'viewType', 'long');
      }
      this.$set(this, 'slug', value);
      this.$set(this, 'dataRewards', []);
      self = this;

      axios
        .get(`/api/lotto/reward/${self.slug}/${self.dateSelect}`)
        .then((response) => {
          self.$set(self, 'dataRewards', response.data);
          const array = response.data;
          let tempRound = '';
          let tempThaiDate = '';
          let tempCurrentRoundID = '';
          let tempTwodigit = '';
          let temptreedigit = '';
          array.forEach((element) => {
            tempRound = `${element.master.name} ${element.readable_edition}`;
            tempThaiDate = element.game_thai_date;
            if (element.status == 'complete') {
              tempCurrentRoundID = element.id;
              tempTwodigit = element.results[0].result_value;
              temptreedigit = element.results[1].result_value;
            }
          });
          self.$set(self, 'roundCurrent', tempRound);
          self.$set(self, 'gameThaiDate', tempThaiDate);
          self.$set(self, 'idCurrent', tempCurrentRoundID);
          self.$set(self, 'twoDigitCurrent', tempTwodigit);
          self.$set(self, 'treeDigitCurrent', temptreedigit);
        });
    },
    changeType(value) {
      this.$set(this, 'viewType', value);
    },
    classActive(value) {
      if (value == this.slug) {
        return 'active';
      }
      return '';
    },
    buttonActive(value) {
      if (value == this.idCurrent) {
        return 'active';
      }
      return '';
    },
    typeActive(value) {
      if (value == this.viewType) {
        return 'active';
      }
      return '';
    },
    spritRoundName(value) {
      const splitedStr = value.split('|');
      return splitedStr[1];
    },
    changeCurrent(round, two, three) {
      this.$set(this, 'roundCurrent', round);
      this.$set(this, 'twoDigitCurrent', two);
      this.$set(this, 'treeDigitCurrent', three);
    },
  },
};
</script>
